import React, { useState } from 'react';

const FAQ = ({ items, defaultOpen = 0 }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="v2-faq">
      {items.map((it, i) => (
        <div key={i} className={`v2-faq__item ${open === i ? 'v2-faq__item--open' : ''}`}>
          <button
            className="v2-faq__q"
            onClick={() => setOpen(open === i ? -1 : i)}
            aria-expanded={open === i}
          >
            <span>{it.q}</span>
          </button>
          <div className="v2-faq__a">{it.a}</div>
        </div>
      ))}
    </div>
  );
};

export default FAQ;
